import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Staff Compliance service — talks to /api/carehome-manager/compliance.
 * `save` sends multipart/form-data because a proof file may be attached.
 */
const complianceService = {
  // Full board: every staff member with their rtw/dbs checks + summary tiles.
  list: async () => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`/${routePath}/compliance`);
    return response.data;
  },

  // Create/update a check. `formData` is a FormData (may include a `proof` file).
  save: async (formData) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`/${routePath}/compliance`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Mark a check reviewed.
  review: async (id) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.patch(`/${routePath}/compliance/${id}/review`);
    return response.data;
  },
};

export default complianceService;
